export const certificationRoutes = [
  {
    path: '/certifications',
    name: 'certifications',
    component: () => import('./views/Certifications.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
]
